<template>
  <div class="cs-panel-main">
    <div class="cs-panel-title">
      <artisticalLabel :backgroundText="universityName" labelText="我的校区" />
    </div>
    <div class="cs-panel-content">
      <el-carousel :interval="5000" type="card" height="300px">
        <el-carousel-item v-for="(item, index) in pictures" :key="index">
          <img :src="require(`@/assets/studentLanding/${universityName}/${item}`)" class="image" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { universities } from "@/service/studentLanding.service";

export default {
  name: "myUniversity",
  components: {
    artisticalLabel: () => import("../common/artisticalLabel"),
  },
  props: {
    dataIn: {
      university: {
        type: Number,
        default: 0,
      },
    },
  },
  beforeCreate() {
    this.universities = universities;
  },
  computed: {
    universityName() {
      let universityItem = this.universities.valueOf(this.dataIn.university);
      return !!universityItem ? universityItem.key : String.empty;
    },
    pictures() {
      let value = this.universities.getAttrValue(
        this.dataIn.university,
        "pictures",
        []
      );
      return value;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.cs-panel-main {
  .cs-panel-title {
    text-align: center;
    padding: 0px;
  }

  .cs-panel-content {
    text-align: center;
    padding-top: 64px;

    .el-carousel__item {
      line-height: 300px;

      .image {
        width: 400px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studentLanding/myUniversity.vue